// DashAI workflow video categories for the Learn Hub Tutorials tab.
//
// Derived from the `workflowAgents` registry in
// `features/dashai/components/dashai/WorkflowAgentsGrid.tsx` at call time
// so this list stays in sync as workflows are added, renamed, or given videos.
//
// Filtering:
//  - Flagship only: `hasInputDialog: true`, not `isUpcoming`,
//    `isNavigationShortcut`, or `isDashboard`.
//  - Must have a `storagePath` — workflows without an uploaded video are
//    omitted entirely (no "Coming Soon" placeholder).
//  - Workspace-aware: callers pass `visibleWorkflowIds` (a Set<string> from
//    `useWorkflowVisibility`). When provided, only workflows whose id is in
//    the set are shown — matching the main workflow grid's behaviour so
//    workspaces never see workflows they shouldn't.

import { workflowAgents, WORKFLOW_DETAIL_CONTENT } from "../features/dashai/components/dashai/WorkflowAgentsGrid";

const isFlagshipWorkflow = (agent) =>
  agent.hasInputDialog === true &&
  !agent.isUpcoming &&
  !agent.isNavigationShortcut &&
  !agent.isDashboard;

const toVideoEntry = (agent) => {
  const detail = WORKFLOW_DETAIL_CONTENT[agent.id];

  return {
    id: `dashai-workflow-${agent.id}`,
    category: "DashAI Workflow",
    title: agent.name,
    sectionName: agent.name,
    shortDescription: agent.description,
    description: detail?.description || agent.description,
    storagePath: detail.storagePath,
    videoKind: "workflow",
    duration: "",
  };
};

const byTitle = (a, b) => a.title.localeCompare(b.title);

export const buildDashaiWorkflowCategories = (visibleWorkflowIds) => {
  const videos = workflowAgents
    .filter(isFlagshipWorkflow)
    .filter((agent) =>
      visibleWorkflowIds ? visibleWorkflowIds.has(agent.id) : true
    )
    .filter((agent) => Boolean(WORKFLOW_DETAIL_CONTENT[agent.id]?.storagePath))
    .map(toVideoEntry)
    .sort(byTitle);

  if (videos.length === 0) return [];

  return [
    {
      id: "dashai-workflows-available",
      title: "Workflow Videos",
      videos,
    },
  ];
};
